export default __webpack_public_path__ + "static/media/gallery_03.8322a910.jpg";